import { useTranslation } from 'react-i18next';
import { GovGrid, GovGridItem, GovSkeleton } from '@gov-design-system-ce/react';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service';
import { LayoutGap } from '@gov-nx/ui/web';
import { GridSkeleton } from '../../Skeleton/GridSkeleton';

export const ProfilROBSkeleton = () => {
	const { t: tg } = useTranslation(LocalizeNameSpaceTypes.Global);
	const processingLabel = tg('loading.wcag.processing', {
		namespace: LocalizeNameSpaceTypes.Global,
	});

	return (
		<GovGrid
			gap="xl"
			className="py-4">
			<GovGridItem
				column="12"
				columnMd="2">
				<GovSkeleton
					height="128px"
					width="100px"
					aria-label={processingLabel}
				/>
			</GovGridItem>
			<GovGridItem
				column="12"
				columnMd="10">
				<LayoutGap gap="xl">
					<GridSkeleton rows={9} />
					<GovSkeleton
						height="40px"
						width="190px"
						aria-label={processingLabel}
					/>
				</LayoutGap>
			</GovGridItem>
		</GovGrid>
	);
};
